"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Box_1 = __importDefault(require("@mui/material/Box"));
const x_date_pickers_1 = require("@mui/x-date-pickers");
const AdapterMoment_1 = require("@mui/x-date-pickers/AdapterMoment");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const MonthRangePicker = ({ dateRange, onChange, fullWidth, }) => {
    const [fromOpen, setFromOpen] = (0, react_1.useState)(false);
    const [toOpen, setToOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterMoment_1.AdapterMoment },
        react_1.default.createElement(Box_1.default, { sx: { p: 2 } },
            react_1.default.createElement(x_date_pickers_1.DatePicker, { open: fromOpen, onOpen: () => setFromOpen(true), onClose: () => setFromOpen(false), views: ['year', 'month'], label: "From", maxDate: dateRange[1], value: dateRange[0], onChange: (e) => {
                    if (e) {
                        onChange([e, dateRange[1]]);
                    }
                }, slotProps: { textField: { fullWidth: fullWidth, onClick: () => setFromOpen(true) } } })),
        react_1.default.createElement(Box_1.default, { sx: { p: 2 } },
            react_1.default.createElement(x_date_pickers_1.DatePicker, { open: toOpen, onOpen: () => setToOpen(true), onClose: () => setToOpen(false), views: ['year', 'month'], label: "To", minDate: dateRange[0], maxDate: (0, moment_1.default)(), value: dateRange[1], onChange: (e) => {
                    if (e) {
                        onChange([dateRange[0], e]);
                    }
                }, slotProps: { textField: { fullWidth: fullWidth, onClick: () => setToOpen(true) } } }))));
};
exports.default = MonthRangePicker;
